import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import { ProjectSaleInfo } from '../model/projectsale.model';
import { EmpInfo } from '../model/emp.model';
import { SaleOrganizationInfo } from '../model/SaleOrganization.model';
import { GlobalService } from '../service/global.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  FormArray
} from '@angular/forms';

import {
  HttpClient,
  HttpHeaders
} from "@angular/common/http";
import {
  environment
} from 'src/environments/environment';
import { LookupInfo } from '../model/lookup.model';
import { CompanyInfo } from '../model/company.model';
import { async } from '@angular/core/testing';
import { strict } from 'assert';
import { data } from 'jquery';
import { SaletrackingInfo } from '../model/saletracking.model';
import { ProjectGroupInfo } from '../model/ProjectGroupInfo';
import { TokenService } from '../service/token.service';

@Component({
  selector: 'app-projectgroup-management',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './projectgroup-management.component.html',
  styleUrls: ['./projectgroup-management.component.css']
})
export class ProjectgroupManagementComponent implements OnInit {

  form: FormGroup;
  public body: string;
  ProjectSaleListPromise: Promise<ProjectGroupInfo[]>
  ProjectSaleList: ProjectGroupInfo[]
  ProjectSaleListPromisereturn: Promise<ProjectGroupInfo[]>[]
  CompanyList: CompanyInfo[]
  CategoryList: LookupInfo[]
  StatusList: LookupInfo[]
  ProjectSaleTypeList: LookupInfo[]
  ProjectSalePhaseList: LookupInfo[]
  ProjectSaleCustomerTypeList: LookupInfo[]
  EmployeeList: EmpInfo[]
  empList: EmpInfo[]
  empListLoad: EmpInfo[]
  empListPromise: Promise<EmpInfo[]>
  empListPromiseReturn: Promise<EmpInfo[]>
  saleOrganizationList: SaleOrganizationInfo[]
  saleOrganizationPromise: Promise<SaleOrganizationInfo[]>
  saleOrganizationMaxList: SaleOrganizationInfo[]

  // array control
  itemsSupport: FormArray;

  flagduplicate: boolean;
  hidProjectSaleId: number

  // Zone pagination variable
  public indexNo: number = 0
  public currentPageNumber: number
  public totalPages: number
  public environment: number
  public empcodeinit: string
  _EmpCode: string;
  hidebutton: Boolean;
  assignflag: boolean;
  viewflag: boolean;
  saleorglevelmax: number;
  saleorglevelemplogin: number;
  public currentPageNumberEmp: number
  public totalPagesEmp: number
  ProjectTotal: any
  EmpTotal: any
  isOnUpdate: boolean;
  isSubmitted: any;
  public totalActive: number
  public totalInActive: number
  public totalHold: number
  public totalClosed: number
  element: HTMLElement;
  public hidcouchk: number;
  public countall: number;
  baseurl: string;
  getreturn: Promise<string>;
  monthNameslist: any;
  yearlist: any[];

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder
    , private GlobalService: GlobalService, private TokenService: TokenService) {
    this.baseurl = environment.base_api;
    GlobalService.CheckPagingAccessRights();
  }

  async ngOnInit() {

    this.currentPageNumber = 1;
    // set PageSize
    this.environment = environment.PageSizeSmall;

    this.empcodeinit = localStorage.getItem("EmpCode");
    this._EmpCode = localStorage.getItem("EmpCode");
    this.currentPageNumberEmp = 1;
    this.form = this.formBuilder.group({
      ProjectSaleCodeSearch: [null],
      ProjectSaleNameSearch: [null],
      ProjectSaleCompanyIdSearch: [null],
      ProjectSaleStatusSearch: [null],
      ProjectGroupMapping: [null],
      ProjectGroup: [null],
      ProjectGroupName: [null],
      ProjectSaleCompanyId: [null],
      ProjectSaleStatus: [null],
      CreateBy: localStorage.getItem("EmpName_TH"),
      arraySupportTeam: this.formBuilder.array([this.createItemSupportTeamName()]),
      EmpCodeSearch: [null],
      EmpNameSearch: [null]
    });

    this.Clearinput();

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.loadCompany(auth_token).then((data) => {
        this.CompanyList = data;
      });

      this.loadEmployee(auth_token).then((data) => {
        this.EmployeeList = data;
      });

      this.loadLookup('PROJECTSALECATEGORY', auth_token).then((data) => {
        this.CategoryList = data;
      });

      this.loadLookup('PROJECTSALESTATUS', auth_token).then((data) => {
        this.StatusList = data;
      });

      this.loadLookup('PROJECTSALETYPE', auth_token).then((data) => {
        this.ProjectSaleTypeList = data;
      });

      this.loadLookup('PROJECTSALEPHASE', auth_token).then((data) => {
        this.ProjectSalePhaseList = data;
      });

      this.loadLookup('COMPANYCUSTOMERTPYE', auth_token).then((data) => {
        this.ProjectSaleCustomerTypeList = data;
      });

      this.LoadSaleOrganizationLevel(auth_token);
      this.LoadListProjectGroup(auth_token);
      this.LoadCountProjectGroup(auth_token);
    }
  }

  btnClick_SearchProjectSaleList() {
    this.currentPageNumber = 1; // away current page 1 when search
    this.indexNo = 0;
    this.LoadProjectSale()
  }
  Clearinput() {
    var d = new Date();
    var monthindex = d.getMonth() + 1;
    var year = d.getFullYear();

    this.form.patchValue({
      ProjectGroupMapping: null,
      ProjectGroup: null,
      ProjectGroupName: null,
      ProjectSaleCompanyId: null,
      ProjectSaleStatus: null,
      CreateBy: localStorage.getItem("EmpName_TH"),
    });

    // clear support team
    this.itemsSupport = this.form.get('arraySupportTeam') as FormArray;
    this.itemsSupport.clear();
    this.itemsSupport.push(this.createItemSupportTeamName());

  }

  createItemSupportTeamName(value = ''): FormGroup {
    return this.formBuilder.group({
      SupporTeamName: [value],
    },
      {
        // Used custom form validator 
        validator: []
      }
    );

  }

  addSupport(): void {
    this.itemsSupport = this.form.get('arraySupportTeam') as FormArray;
    this.itemsSupport.push(this.createItemSupportTeamName());
  }

  removeSupportItem(indexitem): void {
    this.itemsSupport = this.form.get('arraySupportTeam') as FormArray;
    this.itemsSupport.removeAt(indexitem);
  }

  ClearSearch() {
    this.form.patchValue({
      ProjectSaleCodeSearch: "",
      ProjectSaleNameSearch: "",
      ProjectSaleCompanyIdSearch: "",
      ProjectSaleStatusSearch: "",
    });
    this.currentPageNumber = 1;
    this.indexNo = 0;
    this.LoadProjectSale();
  }

  LoadProjectSale(traget = null) {

    // check call function from change page or onloadfrist
    if (traget != null) {
      this.LoadProjectSaleUpdatePagination(traget);
    }

    this.LoadProjectSaleList();
    this.LoadProjectSaleCountList();
  }

  async LoadProjectSaleList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * this.environment;

      var objectjson = {};
      objectjson['ProjectGroup'] = this.checkUndefinedString(this.form.controls['ProjectSaleCodeSearch'].value);
      objectjson['ProjectGroupName'] = this.checkUndefinedString(this.form.controls['ProjectSaleNameSearch'].value);
      objectjson['CreateBy'] = this.checkUndefinedString(this.form.controls['ProjectSaleCompanyIdSearch'].value);
      objectjson['rowFetch'] = this.environment;
      objectjson['rowOFFSet'] = offset;
      if (this.viewflag == true) {

      }
      else {
        objectjson['ProjectSaleCreateBy'] = this.checkUndefinedString(this.empcodeinit);
      }
      objectjson['ProjectSaleActiveFlag'] = "Y";
      objectjson['ProjectSaleFlagDelete'] = "N";


      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<ProjectGroupInfo[]>(this.baseurl + "Master/GetProjectGroup", strjson, httpOptions)
        .toPromise().then((data) => {

          this.ProjectSaleList = data

        });
    }
  }

  async LoadProjectSaleCountList() {

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectGroup'] = this.checkUndefinedString(this.form.controls['ProjectSaleCodeSearch'].value);
      objectjson['ProjectGroupName'] = this.checkUndefinedString(this.form.controls['ProjectSaleNameSearch'].value);
      objectjson['CreateBy'] = this.checkUndefinedString(this.form.controls['ProjectSaleCompanyIdSearch'].value);

      if (this.viewflag == true) {
      }
      else {
        objectjson['ProjectSaleCreateBy'] = this.checkUndefinedString(this.empcodeinit);
      }
      objectjson['ProjectSaleActiveFlag'] = "Y";
      objectjson['ProjectSaleFlagDelete'] = "N";

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<ProjectGroupInfo[]>(this.baseurl + "Master/GetProjectGroup", strjson, httpOptions)
        .toPromise().then((data) => {
          this.hidcouchk = data.length;
          if (this.hidcouchk == 0) {
            this.currentPageNumber = 0;
            this.totalPages = 0;
          } else {
            this.totalPages = Math.ceil(this.hidcouchk / this.environment);
          }

        })
    }
  }

  async btnClick_submitInsertProjectSale() {

    if (this.form.valid) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        console.log('form submitted');
        this.OnCreating('y');

        // gen array support control to json
        this.itemsSupport = this.form.get('arraySupportTeam') as FormArray;
        var jsonsupportteam = this.ConvertFormArrayToJson(this.itemsSupport);
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};
        objectjson['ProjectGroup'] = this.checkUndefinedString(this.form.controls['ProjectGroup'].value);
        objectjson['ProjectGroupName'] = this.checkUndefinedString(this.form.controls['ProjectGroupName'].value);
        objectjson['CreateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
        objectjson['FlagDelete'] = "N";

        let strjson = JSON.stringify(objectjson);

        this.isSubmitted = this.httpClient.post<ProjectGroupInfo[]>(this.baseurl + "Master/InsertProjectGroup", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Insert fail")
            this.OnCreating('n');
          },
            () => {
              console.log("Insert = " + this.isSubmitted)
              this.OnCreating('n');
              $('#ModalCreateComplate').modal();
              this.currentPageNumber = 1;
              this.indexNo = 0;
              this.LoadProjectSale();
            }
          )

      } else {
        this.GlobalService.validateAllFormFields(this.form);
      }
    }
  }

  btnClick_onUpdateProjectSale(id) {
    $('#ModalProjectSale').modal('hide');
    //this.Clearinput();
    this.isOnUpdate = true

    let index = this.ProjectSaleList.findIndex(x => x.ProjectGroupID == id);

    var d = new Date();
    var monthindex = d.getMonth() + 1;
    var yearcurrent = d.getFullYear();

    this.form.patchValue({
      
      ProjectGroup: this.ProjectSaleList[index].ProjectGroup != null ? this.ProjectSaleList[index].ProjectGroup : null,
      ProjectGroupName: this.ProjectSaleList[index].ProjectGroupName != null ? this.ProjectSaleList[index].ProjectGroupName : null,
      
    });

    this.hidProjectSaleId = this.ProjectSaleList[index].ProjectGroupID

    $('#ModalProjectSale').modal();

  }

  async btnClick_submitUpdateProjectSale(id) {
    if (this.form.valid) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.OnUpdating('y');
        id = this.hidProjectSaleId

        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};
        objectjson['ProjectGroupID'] = id;
        objectjson['ProjectGroup'] = this.checkUndefinedString(this.form.controls['ProjectGroup'].value);
        objectjson['ProjectGroupName'] = this.checkUndefinedString(this.form.controls['ProjectGroupName'].value);
        objectjson['UpdateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));

        let strjson = JSON.stringify(objectjson);

        this.isSubmitted = this.httpClient.post<ProjectGroupInfo[]>(this.baseurl + "Master/UpdateProjectGroup", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail");
            this.OnUpdating('n');
          },
            () => {
              console.log("Update = " + this.isSubmitted);
              this.OnUpdating('n');
              $('#ModalUpdateComplate').modal();
              this.LoadProjectSale();
            }
          )
      } else {
        this.GlobalService.validateAllFormFields(this.form);
      }
    }
  }

  btnClick_deleteProjectSale(id): Observable<ProjectGroupInfo[]> {
    var auth_token = this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var objectjson = {};
      objectjson['ProjectGroupID'] = id;

      let strjsonCusInfo = JSON.stringify(objectjson);

      return this.httpClient.post<ProjectGroupInfo[]>(this.baseurl + "Master/DeleteProjectGroup", strjsonCusInfo, httpOptions);
    }
  }

  chkallclick(traget) {
    var check = $(traget.currentTarget).is(":checked");

    $('[name="checkboxProjectSale"]').prop('checked', check);

  }

  btnClick_deleteProjectSaleitem(id) {

    if (confirm("Are you sure you want to delete this Project ?")) {
      this.btnClick_deleteProjectSale(parseInt(id)).toPromise()
        .then(
          data => {
            console.log('หลังรับค่า');
            $('#ModalDeleteComplate').modal('show');
            this.LoadProjectSale();
          }
        );
    }

  }

  //Delete แบบ list
  btnClick_onDeleteProjectSaleList() {

    if (confirm("Are you sure you want to delete this Project?")) {

      var checkkedProjectSale = $('[name="checkboxProjectSale"]:checked');

      let num = checkkedProjectSale.length;
      let observableBatch = [];
      for (var i = 0; i < num; i++) {

        var ProjectSalecurrent = <HTMLInputElement>checkkedProjectSale[i];
        observableBatch.push(this.btnClick_deleteProjectSale(parseInt(ProjectSalecurrent.value)).toPromise().then(val => {
        }));
      }

      Promise.all(observableBatch).then(val => {

        this.SendListIdToDelete(observableBatch);

      });

    }

  }
  async SendListIdToDelete(observableBatch: any[]) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjsonCusInfo = JSON.stringify(observableBatch);

      return this.httpClient.post<ProjectGroupInfo[]>(this.baseurl + "Master/DeleteListProjectGroup", strjsonCusInfo, httpOptions)
        .toPromise()
        .then(
          data => {
            console.log('สำเร็จ');
            $('#ModalDeleteComplate').modal('show');
            this.currentPageNumber = 1;
            this.LoadProjectSale();
          }
        );
    }
  }

  btnClick_onCreateProjectSale() {
    this.form.reset();
    $('#ModalProjectSale').modal('show');
    this.Clearinput();
    this.isOnUpdate = false
  }

  isFieldValid(field: string) {
    return !this.form.get(field).valid && this.form.get(field).touched;
  }

  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }

  async loadCompany(auth_token) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    var objectjson = {};

    let strjson = JSON.stringify(objectjson);

    return await this.httpClient.post<CompanyInfo[]>(this.baseurl + "Company/GetCompany", strjson, httpOptions)
      .toPromise()
  }

  async loadEmployee(auth_token) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    var objectjson = {};

    let strjson = JSON.stringify(objectjson);

    return await this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/GetEmployeeCriteria", strjson, httpOptions)
      .toPromise()
  }

  async loadLookup(lookuptype: string, auth_token:string) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    var objectjson = {};
    objectjson['LookupType'] = this.checkUndefinedString(lookuptype);

    let strjson = JSON.stringify(objectjson);

    return await this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
      .toPromise()
  }

  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput
  }

  OnCreating(flag) {
    if (flag == 'y') {
      $("#loadingcreate").show();
      $("#btnsubmitProjectSale").hide();
      $("#txtProjectSaleCode").prop('disabled', true);
      $("#txtProjectSaleName").prop('disabled', true);
      $("#txtProjectSaleContactName").prop('disabled', true);
      $("#txtProjectSaleLink").prop('disabled', true);
      $("#txtProjectSaleIndustry").prop('disabled', true);
      $("#txtProjectSaleCustomerType").prop('disabled', true);
      $("#txtProjectSaleDescription").prop('disabled', true);
      $('#btncloseicon').prop('disabled', true);
      $('#btnclose').prop('disabled', true);
    } else if (flag == 'n') {
      $("#loadingcreate").hide();
      $("#btnsubmitProjectSale").show();
      $("#txtProjectSaleCode").removeAttr('disabled');
      $("#txtProjectSaleName").removeAttr('disabled');
      $("#txtProjectSaleContactName").removeAttr('disabled');
      $("#txtProjectSaleLink").removeAttr('disabled');
      $("#txtProjectSaleIndustry").removeAttr('disabled');
      $("#txtProjectSaleCustomerType").removeAttr('disabled');
      $("#txtProjectSaleDescription").removeAttr('disabled');
      $('#btncloseicon').removeAttr('disabled');
      $('#btnclose').removeAttr('disabled');
      $('#ModalProjectSale').modal('hide');
    }

  }

  OnUpdating(flag) {
    if (flag == 'y') {
      $("#loadingupdate").show();
      $("#btnsubmitProjectSale").hide();
      $("#txtProjectSaleCode").prop('disabled', true);
      $("#txtProjectSaleName").prop('disabled', true);
      $("#txtProjectSaleContactName").prop('disabled', true);
      $("#txtProjectSaleLink").prop('disabled', true);
      $("#txtProjectSaleIndustry").prop('disabled', true);
      $("#txtProjectSaleCustomerType").prop('disabled', true);
      $("#txtProjectSaleDescription").prop('disabled', true);
      $('#btncloseicon').prop('disabled', true);
      $('#btnclose').prop('disabled', true);
    } else if (flag == 'n') {
      $("#loadingupdate").hide();
      $("#btnsubmitProjectSale").show();
      $("#txtProjectSaleCode").removeAttr('disabled');
      $("#txtProjectSaleName").removeAttr('disabled');
      $("#txtProjectSaleContactName").removeAttr('disabled');
      $("#txtProjectSaleLink").removeAttr('disabled');
      $("#txtProjectSaleIndustry").removeAttr('disabled');
      $("#txtProjectSaleCustomerType").removeAttr('disabled');
      $("#txtProjectSaleDescription").removeAttr('disabled');
      $('#btncloseicon').removeAttr('disabled');
      $('#btnclose').removeAttr('disabled');
      $('#ModalProjectSale').modal('hide');
    }

  }

  displayhyperlink(projectcode: string, projectsaleid: number) {
    var body = ""
    body += " <a href=\"/saletracking-management?ProjectSaleID=" + projectsaleid + "\">" + projectcode + "</a>"

    return body;
  }

  async btnonclick_loadcompany() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.loadCompany(auth_token).then((data) => {
        this.CompanyList = data;
      });
    }
  }

  async btnonclick_loadCategory() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.loadLookup('PROJECTSALECATEGORY', auth_token).then((data) => {
        this.CategoryList = data;
      });
    }
  }

  btnClick_onAssignEmpClick() {
    $('#ModalEmpAssign').modal('show');
  }

  ClearSearchEmp() {
    this.form.patchValue({
      EmpCodeSearch: "",
      EmpNameSearch: "",
    });
  }

  async LoadEmp() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.LoadEmpList(auth_token)
        .then(
          data => {
            this.empList = data;
          }
      ).then(() => {

        this.CountEmpList(auth_token);
        })
    }
  }

  LoadEmpList(auth_token): Promise<EmpInfo[]> {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    let offset = (this.currentPageNumberEmp - 1) * environment.PageSize;

    var objectjson = {};
    objectjson['EmpCode'] = this.checkUndefinedString(this.form.controls['EmpCodeSearch'].value);
    objectjson['EmpName_TH'] = this.checkUndefinedString(this.form.controls['EmpNameSearch'].value);
    objectjson['FlagDelete'] = 'N';
    objectjson['rowFetch'] = environment.PageSize;
    objectjson['rowOFFSet'] = offset;

    let strjson = JSON.stringify(objectjson);

    this.empListPromise = this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/GetEmployeeCriteria", strjson, httpOptions)
      .toPromise()

    return this.empListPromise;
  }

  CountEmpList(auth_token) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    let offset = (this.currentPageNumberEmp - 1) * environment.PageSize;

    var objectjson = {};
    objectjson['EmpCode'] = this.checkUndefinedString(this.form.controls['EmpCodeSearch'].value);
    objectjson['EmpName_TH'] = this.checkUndefinedString(this.form.controls['EmpNameSearch'].value);
    objectjson['FlagDelete'] = 'N';

    let strjson = JSON.stringify(objectjson);

    this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/GetCountEmployeeCriteria", strjson, httpOptions)
      .toPromise().then(data => {
        this.EmpTotal = data;
        if(this.EmpTotal == 0) this.currentPageNumberEmp = 0;
      })
      .then(() => {
        this.totalPagesEmp = Math.ceil(this.EmpTotal / environment.PageSize);
      })

  }

  btnClickshowEmp() {
    this.LoadEmpforAssign();

  }

  btnClick_previous() {
    if (this.currentPageNumberEmp == 1) {

    } else {
      this.currentPageNumberEmp -= 1
      this.LoadEmp();
    }

  }

  btnClick_next() {
    if (this.currentPageNumberEmp == this.totalPagesEmp) {

    } else {
      this.currentPageNumberEmp += 1
      this.LoadEmp();
    }
  }

  btnClick_first() {
    if (this.currentPageNumberEmp == 1) {

    } else {
      this.currentPageNumberEmp = 1
      this.LoadEmp();
    }

  }

  btnClick_last() {
    if (this.currentPageNumberEmp == this.totalPagesEmp) {

    } else {
      this.currentPageNumberEmp = this.totalPagesEmp
      this.LoadEmp();
    }
  }

  LoadSaleOrganizationLevel(auth_token) {

    this.LoadSaleOrganizationLevelList(auth_token)
      .then(data => {
      this.saleOrganizationList = data;

      //console.log("SaleOrganization List : " + JSON.stringify(this.saleOrganizationList));

      if (this.saleOrganizationList.length > 0) {
        if (this.saleOrganizationList[0].AssignFlag == 'Y') {
          this.hidebutton = false;
          this.assignflag = false;
        }
        else {
          this.hidebutton = true;
          this.assignflag = true;
        }
      }
      else {
        this.hidebutton = true;
        this.assignflag = true;
      }

      if (this.saleOrganizationList.length > 0) {
        if (this.saleOrganizationList[0].ViewFlag == 'Y') {
          this.viewflag = true;
        }
        else {
          this.viewflag = false;
        }
      }
      else {
        this.viewflag = false;
      }

      if (this.saleOrganizationList.length > 0) {
        this.saleorglevelemplogin = this.saleOrganizationList[0].Levels
      }
      else {
        this.saleorglevelemplogin = 1;
      }

      this.LoadProjectSale();
      }).then(async () => {
        var auth_token = await this.TokenService.RefreshToken();
        if (!!auth_token) {
          this.LoadSaleOrganizationLevelmax(auth_token);
        }
    });
  }

  LoadSaleOrganizationLevelList(auth_token): Promise<SaleOrganizationInfo[]> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    let offset = (this.currentPageNumberEmp - 1) * environment.PageSize;

    var objectjson = {};
    objectjson['EmpCode'] = this.checkUndefinedString(this.empcodeinit);

    let strjson = JSON.stringify(objectjson);

    this.saleOrganizationPromise = this.httpClient.post<SaleOrganizationInfo[]>(this.baseurl + "SaleOrganization/GetSaleOrganization", strjson, httpOptions)
      .toPromise()

    return this.saleOrganizationPromise;
  }

  LoadSaleOrganizationLevelmax(auth_token) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    let offset = (this.currentPageNumberEmp - 1) * environment.PageSize;

    var objectjson = {};

    let strjson = JSON.stringify(objectjson);

    this.httpClient.post<SaleOrganizationInfo[]>(this.baseurl + "SaleOrganization/GetSaleOrganization", strjson, httpOptions)
      .toPromise().then(
        data => {
          this.saleOrganizationMaxList = data;
          this.saleOrganizationMaxList = this.saleOrganizationMaxList.sort((a, b) => a.Levels - b.Levels);

          if (this.saleOrganizationMaxList.length > 0) {
            this.saleorglevelmax = this.saleOrganizationMaxList[this.saleOrganizationMaxList.length - 1].Levels;

          }
          else {
            this.saleorglevelmax = 1;
          }

          this.LoadEmpforAssign();
        })
  }

  async LoadEmpforAssign() {

    if (this.saleorglevelemplogin > 1 && this.saleorglevelmax > 1) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        let offset = (this.currentPageNumberEmp - 1) * environment.PageSize;

        var objectjson = {};
        objectjson['saleorglevel'] = this.saleorglevelemplogin;
        objectjson['saleorglevelmax'] = this.saleorglevelmax;
        objectjson['rowFetch'] = environment.PageSize;
        objectjson['rowOFFSet'] = offset;
        objectjson['EmpCode'] = this.checkUndefinedString(this.form.controls['EmpCodeSearch'].value);
        objectjson['EmpName_TH'] = this.checkUndefinedString(this.form.controls['EmpNameSearch'].value);

        let strjson = JSON.stringify(objectjson);

        this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/GetEmpforAssignProjectSale", strjson, httpOptions)
          .toPromise().then(
            data => {
              this.empListLoad = data;

              //alert(JSON.stringify(this.empListLoad[0].Id));
              //console.log("JSON result empassign : " + JSON.stringify(this.empListLoad));
            }).then(() => {
              this.CountLoadEmpforAssign();
            })
      }
    }
    else {
      this.empListLoad = [];
      //console.log("JSON result empassign : " + JSON.stringify(this.empListLoad));
    }
  }

  async CountLoadEmpforAssign() {
    if (this.saleorglevelemplogin > 1 && this.saleorglevelmax > 1) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`

          })
        };

        let offset = (this.currentPageNumberEmp - 1) * environment.PageSize;

        var objectjson = {};
        objectjson['saleorglevel'] = this.saleorglevelemplogin;
        objectjson['saleorglevelmax'] = this.saleorglevelmax;
        objectjson['EmpCode'] = this.checkUndefinedString(this.form.controls['EmpCodeSearch'].value);
        objectjson['EmpName_TH'] = this.checkUndefinedString(this.form.controls['EmpNameSearch'].value);

        let strjson = JSON.stringify(objectjson);

        this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/GetCountEmpforAssignProjectSale", strjson, httpOptions)
          .toPromise().then(data => {
            this.EmpTotal = data;
            if(this.EmpTotal == 0) this.currentPageNumberEmp = 0;
          })
          .then(() => {
            this.totalPagesEmp = Math.ceil(this.EmpTotal / environment.PageSize);
          })
      }
    }
    else {
      this.EmpTotal = 0;
    }

  }

  assignclicked(item) {

    if (confirm("Are you sure you want to assign sale employee?")) {

      $('#ModalEmpAssign').modal('hide');
      let EmpCode = this.empListLoad.findIndex(x => x.Id == item);

      var checkkedProjectSale = $('[name="checkboxProjectSale"]:checked');

      let num = checkkedProjectSale.length;
      let observableBatch = [];

      for (var i = 0; i < num; i++) {

        var ProjectSalecurrent = <HTMLInputElement>checkkedProjectSale[i];
        observableBatch.push((this.btnClick_assignProjectSale(parseInt(ProjectSalecurrent.value), item, this._EmpCode)).then(val => {
        }));
      }

      Promise.all(observableBatch).then(val => {
        console.log('สำเร็จ');
        $('#ModalEmpAssignComplate').modal('show');
        this.LoadProjectSale();
        this.LoadEmpforAssign();
      });
    }
  }

  async btnClick_assignProjectSale(id, AssignTo, AssignBy): Promise<Observable<ProjectSaleInfo[]>> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var objectjson = {};
      objectjson['ProjectSaleId'] = id;
      objectjson['ProjectSaleAssignTo'] = AssignTo;
      objectjson['ProjectSaleAssignBy'] = AssignBy;
      objectjson['ProjectSaleUpdateBy'] = AssignBy;

      let strjsonCusInfo = JSON.stringify(objectjson);

      return this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/AssignEmpProjectSale", strjsonCusInfo, httpOptions);
    }
  }


  ConvertFormArrayToJson(objectFormArray: FormArray): string {
    var objectarray = [];
    $.each(objectFormArray.controls, function (index, value) {
      objectarray.push(value.value);
    });

    return JSON.stringify(objectarray);

  }

  // Function Update variable abount pagination
  LoadProjectSaleUpdatePagination(traget) {
    this.currentPageNumber = traget.currentPageNumber;
    this.totalPages = traget.totalPages;
    this.indexNo = traget.index;

  }

  //Lead group
  //function Update Group projectsale
  //1. Get list project group to modal
  //2. Send list projs id to save 
  //Variables
  listProjGroup: ProjectGroupInfo[] = [];
  totalProjectGroup: number;
  totalPage_ProjectGroup: number;
  currentPageNumber_ProjectGroup: number;

  LoadListProjectGroup(auth_token) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    var objectjson = {};
    let strjson = JSON.stringify(objectjson);

    this.httpClient
      .post<ProjectGroupInfo[]>(this.baseurl + "Master/GetProjectGroup",
        strjson, httpOptions)
      .subscribe(data => {
        this.listProjGroup = data;
       
      });
  }
  LoadCountProjectGroup(auth_token) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    var objectjson = {};
    let strjson = JSON.stringify(objectjson);

    this.httpClient
      .post<number>(this.baseurl + "Master/GetCountProjectGroup",
        strjson, httpOptions)
      .subscribe(data => {

        this.currentPageNumber_ProjectGroup = 1;
        this.totalProjectGroup = data;//จำนวน data ทั้งหมด
        this.totalPage_ProjectGroup = Math.ceil(this.totalProjectGroup / environment.PageSizeSmall);//จำนวนที่แบ่ง page ได้
      });
  }

  async OnLoadProjGroupFinished(traget = null) {
    if (traget != null) { // check call function from change page or onloadfrist
      this.currentPageNumber_ProjectGroup = traget.currentPageNumber;
      this.totalPage_ProjectGroup = traget.totalPages;
    }

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.LoadListProjectGroup(auth_token);
    }
  }

  OnBtnOpenProjectGroupModalClick() {
    $('#ModalProjectGroup').modal();
  }
  OnBtnAssignGroupProjectSaleList(groupcode) {

    if (confirm("Are you sure you want to Update group this Project?")) {

      var checkkedProjectSale = $('[name="checkboxProjectSale"]:checked');
      var Groupproject = groupcode;
      let num = checkkedProjectSale.length;
      let observableBatch = [];
      for (var i = 0; i < num; i++) {

        var ProjectSalecurrent = <HTMLInputElement>checkkedProjectSale[i];

        var projcode = $(ProjectSalecurrent).data('projcode');
        observableBatch.push(this.btnClick_UpdateGroupProjectSale(parseInt(ProjectSalecurrent.value), projcode, Groupproject).toPromise().then(val => {
        }));
      }

      Promise.all(observableBatch).then(val => {


        this.SendListIdToUpdateGroup(observableBatch);

      });

    }

  }

  btnClick_UpdateGroupProjectSale(id, projcode, Groupproject): Observable<ProjectSaleInfo[]> {
    var auth_token = this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      };
      var objectjson = {};
      objectjson['ProjectSaleId'] = id;
      objectjson['ProjectSaleCode'] = projcode;
      objectjson['ProjectGroupMapping'] = Groupproject;

      let strjsonCusInfo = JSON.stringify(objectjson);

      return this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/UpdateGroupProjectSaleByGroup", strjsonCusInfo, httpOptions);
    }
  }
  async SendListIdToUpdateGroup(observableBatch: any[]) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjsonCusInfo = JSON.stringify(observableBatch);

      return this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/UpdateGroupProjectSaleByGroup", strjsonCusInfo, httpOptions)
        .toPromise()
        .then(
          data => {
            console.log('สำเร็จ');
            $('#ModalProjectGroupComplate').modal('show');
            this.currentPageNumber = 1;
            this.LoadProjectSale();

          }
        );
    }
  }
}
